/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadResolvePanel/AadSendInvitePanel" />
import React = require("react");
import AdminResources = require("TFS/Admin/OrganizationAadControls/Resources");
import { IButtonProps } from "VSSUI/Button";
import { ContentSize } from "VSSUI/Callout";
import { Panel } from "VSSUI/Panel";
import { format } from "VSS/Core/Util/String";
import { Checkbox } from "VSSUI/Checkbox";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { createMarkup } from "TFS/Admin/Common/Util/HtmlString";
import { ObservableValue } from "VSS/Core/Observable";
import { Link } from "VSSUI/Link";
import { WrappedComponent } from "VSS/Platform/Layout";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { VssComponent } from "VSS/Platform/Layout";
import { IAadSendInvitePanelComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/ComponentControls.props";

interface IAadSendInvitePanelComponentState {
    userSelectedSendInvite: ObservableValue<boolean>;
}

export class AadSendInvitePanelComponent extends React.Component<IAadSendInvitePanelComponentProps, IAadSendInvitePanelComponentState> {
    public constructor(props: IAadSendInvitePanelComponentProps) {
        super(props);

        this.state = {
            userSelectedSendInvite: new ObservableValue<boolean>(false)
        };
    }

    public render(): JSX.Element {
        const footerButtons: IButtonProps[] = [
            {
                onClick: this.props.onDismiss,
                text: AdminResources.Cancel
            },
            {
                className: "primary-action-button",
                onClick: () => {
                    this.props.onSendInvite(this.state.userSelectedSendInvite.value);
                },
                disabled: false,
                primary: true,
                text: AdminResources.SendInviteDone
            }
        ];

        return (
            <Panel
                onDismiss={this.props.onDismiss}
                titleProps={{ text: AdminResources.SendInvitePanelTitle }}
                description={format(
                    AdminResources.SendInvitePanelDescription,
                    this.props.disconnectedUsers.length,
                    this.props.totalOrgUsers,
                    this.props.orgTenantData.displayName
                )}
                size={ContentSize.Large}
                footerButtonProps={footerButtons}
            >
                {this._renderPanelBody()}
            </Panel>
        );
    }

    private _renderPanelBody(): JSX.Element {
        return (
            <div className="width-100 aad-connect-panel-body">
                {this.props.numberOfUnsuccessMappedUsers > 0 ? (
                    <div className="bottom-margin">
                        <MessageBar severity={MessageBarSeverity.Warning}>
                            <div className="block-display">
                                <span>
                                    <Link className="cursor-pointer" onClick={this.props.onOpenFailureMappingUserDialog}>
                                        <span
                                            dangerouslySetInnerHTML={createMarkup(
                                                format(AdminResources.MappingUserFailureLink, this.props.numberOfUnsuccessMappedUsers)
                                            )}
                                        />
                                    </Link>
                                </span>
                                <span>{AdminResources.MappingUserFailureMessage}</span>
                            </div>
                        </MessageBar>
                    </div>
                ) : null}
                {this.props.numberOfUnsuccessMappedUsers == 0 && this.props.numberOfSuccessMappedUsers > 0 ? (
                    <div className="bottom-margin">
                        <MessageBar severity={MessageBarSeverity.Success}>
                            <div className="block-display">
                                <span>{format(AdminResources.ResolvePanelUserMappingSuccess, this.props.numberOfSuccessMappedUsers)}</span>
                            </div>
                        </MessageBar>
                    </div>
                ) : null}
                <div>
                    <Checkbox
                        onChange={this._onCheckBoxChanged}
                        checked={this.state.userSelectedSendInvite}
                        label={format(AdminResources.SendInviteInfo, this.props.orgTenantData.displayName)}
                        tooltipProps={{ text: format(AdminResources.SendInviteInfo, this.props.orgTenantData.displayName) }}
                    />
                </div>
                <div className="fontWeightSemiBold big-top-margin big-font-size">{AdminResources.SendInviteDisconnectedMembers}</div>
                <div className="small-top-margin users-list-div">
                    <WrappedComponent
                        dependencies={["ms.vss-admin-web.admin-common"]}
                        wrappedType={"ms.vss-admin-web.users-list-component"}
                        users={this.props.disconnectedUsers}
                        avatarSize="medium"
                        pageContext={this.props.pageContext}
                    />
                </div>
                <div className="top-margin">
                    <MessageBar severity={MessageBarSeverity.Info}>
                        <div className="block-display">
                            <div>
                                <FormatComponent format={AdminResources.SendInvitePanelGuestPermission}>
                                    <span>{this.props.orgTenantData.displayName}</span>
                                    <Link href={AdminResources.SendInviteGuestPermissionUrl} target="_blank">
                                        {AdminResources.SendInviteFollowTheseSteps}
                                    </Link>
                                </FormatComponent>
                            </div>
                            <br />
                            <div>
                                <span>{AdminResources.SendInvitePanelInfo}</span>
                                <span>
                                    <Link href={AdminResources.SendInvitePanelLearnMoreLink} target="_blank">
                                        {AdminResources.SendInvitePanelLearnMore}
                                    </Link>
                                </span>
                            </div>
                        </div>
                    </MessageBar>
                </div>
            </div>
        );
    }

    private _onCheckBoxChanged = (ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, isChecked: boolean) => {
        this.setState({
            userSelectedSendInvite: new ObservableValue<boolean>(isChecked)
        });
    };
}

VssComponent.register("ms.vss-admin-web.aad-send-invite-panel", AadSendInvitePanelComponent);
